export default __webpack_public_path__ + "static/media/demandapp.418eb2f4.svg";